<template>
  <div id="container" class="otherBox">
    <div class="otherPaying">
      <img src="../../../static/images/Paying.svg" />
      <div>
        Paying...
      </div>
      <div v-if="nowData>0">
        {{nowData}} s
      </div>
    </div>
    <div class="btn">
      <el-button class="div" :disabled="isDisabled" @click="PayBack()">Back to Card Hobby</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'index',
  components: {},
  data() {
    return {
      isPay: null,
      isText: "",
      oid:'',
      timer:'',
      nowData:5,
      isDisabled:true
      //?type=paysuccess
      //?type=payerror
      //?type=chpsuccess
      //?type=chperror
      //?type=waresuccess
      //?type=wareerror
      //window.webkit.messageHandlers.(name).postMessage(键值对)
    }
  },
  mounted() {
    window.PayBack = this.PayBack;
    this.cardTimer()
  },
  created() {
    this.isPay = (this.$route.query.type.indexOf('success')) != -1 ? true : false
    this.oid=this.$route.query.id
    if (this.$route.query.type.indexOf('pay') != -1) {
      this.isText = "order"
    } else if (this.$route.query.type.indexOf('chp') != -1) {
      this.isText = 'chp'
    } else if (this.$route.query.type.indexOf('ware') != -1) {
      this.isText = 'ware'
    }else if (this.$route.query.type.indexOf('store') != -1) {
      this.isText = 'store'
    }
  },
  methods: {
    //倒计时
    cardTimer() {
      let that=this
      this.timer = setInterval(() => {
        this.nowData = this.nowData - 1;
        if(this.nowData<=0){
          clearInterval(this.timer);
          that.isDisabled=false
          that.PayBack()
        }
      }, 1000);
    },
    PayBack() {
      let that = this
      let ua = navigator.userAgent.toLowerCase();
      //console.log('ua',ua)
      //android终端
      let isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1|| ua.indexOf('android') > -1|| ua.indexOf('adr') > -1;
      //console.log('isAndroid',isAndroid)
      //ios终端
      let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

      let data = { "status": this.isPay ? 1 : 0, "type": this.isText }
      if (!isAndroid) {
        //ios
        //console.log(" 我是ios")
        //这里是和IOS商量好的写法，调用IOS的finishActivity方法
        try {
          window.location.href='https://share.cardhobby.cn?status='+(this.isPay ? 1 : 0)+'&type='+this.isText+'&Id='+this.oid
          window.webkit.messageHandlers.PayCallback.postMessage(data)
        } catch (error) {
          console.log('WKWebView post message');
        }
      } else if(isAndroid){
        //android
        console.log("我是android",JSON.stringify(data));
        //这里是和安卓商量好的写法，调用安卓的finishActivity方法
        //android.PayCallback('我是android测试传值');   
        //
        //
        var url = { open: "#", down: "" };
        url.open = 'cardhobby://h5/open?status='+(this.isPay ? 1 : 0)+'&type='+this.isText+'&id='+this.oid;
        var iframe = document.createElement("iframe");
        iframe.style.display = "none";
        var ti = null;
        document.body.appendChild(iframe);
        iframe.src = url.open;
        ti = setTimeout(function () { location.href = url.open; }, 2000); 
          //window.location.href='https://share.cardhobby.cn?status='+(this.isPay ? 1 : 0)+'&type='+this.isText+'&Id='+this.oid   
        //android.PayCallback(JSON.stringify(data));           
      }
    }
  }
}

</script>
<style scoped>
  .otherBox{
    height: 100vh;
    display: flex;
    flex-direction: column;
  }
  .otherPaying{
      text-align: center;
      color: #5F6DAE;
    font-size: 30px;
    line-height: 1.5;
    font-weight: 700;

  }
  .otherPaying img{
        width: 70%;
    margin: 80px auto 40px;
  }
  .otherPaying span{
    font-size: 24px;
    font-weight: 400;
  }
.btn {
  width: 90%;
  margin: 30px auto;
}

.btn a,
.btn .div {
  width: 100%;
  display: block;
  border-radius: 4px;
  padding: 12px;
  margin: 0 auto;
  text-align: center;
  font-size: 18px;
  color: #fff;
  background-color: #5F6DAE;
}
.btn .div.is-disabled{
  background-color: #C0C4CC;
}

</style>



// WEBPACK FOOTER //
// src/pages/pay/appotherpay.vue